import { render, staticRenderFns } from "./lack-ticket-list.vue?vue&type=template&id=0494c6e3&"
import script from "./lack-ticket-list.vue?vue&type=script&lang=js&"
export * from "./lack-ticket-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports